import "./styles.scss"
import "./print-section.js"

const startCalculator = () => {
  const calculator = document.querySelector('calculator')

  if (calculator) {
    const form = calculator.querySelector('form')

    let results = calculator.querySelectorAll('[data-id]')
    results = Array.from(results).reduce((list, field) => {
      list[field.dataset.id] = field
      return list
    }, {})

    const showAge = () =>
      results.age.innerText = form.age.options[form.age.selectedIndex].text

    showAge()

    class Variables {
      constructor(age, weight) {
        this.age = parseFloat(age)
        this.weight = parseFloat(weight)
      }

      getAge() {
        return this.age
      }

      getWeight() {
        return this.weight
      }

      getTotal() {
        return this.weight * this.age
      }

      getSachets() {
        const total = this.getTotal()

        let quarters = (total < 1000) ?
          Math.ceil(total / 250) :
          Math.round(total / 250)

        let wholes = Math.floor(quarters / 4)

        quarters = quarters % 4

        return {
          wholes: wholes,
          quarters: quarters,
        }
      }

      getVolume() {
        const total = this.getTotal()
        const sachets = this.getSachets()

        const ml = (total < 1000) ?
          // sachets.quarters * 9 :
          Math.round(total / 25 * 5) / 5:
          (sachets.wholes + Math.ceil(sachets.quarters * .25)) * 30

        return {
          ml: ml,
          tbsp: ml / 15,
        }
      }

      setAge(age) {
        this.age = parseFloat(age)
      }

      setWeight(weight) {
        this.weight = parseFloat(weight)
      }
    }

    let vars = new Variables(form.age.value, 0)

    // form.age.addEventListener('input', () => {
    //   vars.setAge(form.age.value)
    //   showAge()
    // })
    //
    // form.weight.addEventListener('input', () => {
    //   vars.setWeight(form.weight.value)
    //   results.weight.innerText = vars.getWeight()
    // })

    const content = calculator.querySelector('.results')
    const stats = calculator.querySelector('.stats')

    form.addEventListener('submit', e => {
      e.preventDefault()

      // disable fields until reset
      // form.age.disabled = true
      // form.weight.disabled = true

      // age
      vars.setAge(form.age.value)
      showAge()

      // weight
      vars.setWeight(form.weight.value)
      results.weight.innerText = vars.getWeight()

      // total
      results.total.innerText = vars.getTotal()

      console.log('test: ' + vars.getTotal())

      if (vars.getTotal() < 1000) {
        content.querySelector('.tbsp').classList.add('hide')
      } else {
        content.querySelector('.tbsp').classList.remove('hide')
      }

      // sachets
      const sachets = vars.getSachets()
      results.s1000.innerText = sachets.wholes
      results.s250.innerText = sachets.quarters

      if (sachets.wholes > 0) {
        content.querySelector('.sachets').classList.remove('zero-wholes')
      } else {
        content.querySelector('.sachets').classList.add('zero-wholes')
      }

      if (sachets.quarters > 0) {
        content.querySelector('.sachets').classList.remove('zero-quarters')
      } else {
        content.querySelector('.sachets').classList.add('zero-quarters')
      }

      // volume
      const volume = vars.getVolume()
      results.tbsp.innerText = volume.tbsp
      results.ml.innerText = volume.ml

      // show it
      content.classList.add('show')
    })

    document.getElementById('reset').addEventListener('click', e => {
      e.preventDefault()

      // enable fields
      // form.age.disabled = false
      // form.weight.disabled = false

      // hide results
      content.classList.remove('show')
      form.weight.value = null
    })

    document.getElementById('print').addEventListener('click', e => {
      e.preventDefault()

      printSection(stats, '/wp-content/themes/operatic/build/index.css')
    })
  }
}
startCalculator()
